import btnMenu from "./modules/btn-menu";
import accordion from "./modules/accordion";
import searchForm from "./modules/searchForm";

$(document).ready(function () {
    btnMenu();
    accordion($('li.title-column > a'), 'li.title-column > ul', 'block-accordion-footer', 'btn-accordion-footer');
    //Header Menu Mob
    accordion($('.footer__info-deliverly .title'), '.footer__info-deliverly .block-info', 'block-accordion-footer', 'btn-accordion-footer');
});

$(window).on('load', function () {
    const recaptchaBadge = document.querySelector('.grecaptcha-badge');
    if (recaptchaBadge) {
        recaptchaBadge.style.opacity = 0;

        const observerLoadMoreScrollCallback = entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    recaptchaBadge.style.opacity = 1;
                } else {
                    recaptchaBadge.style.opacity = 0;
                }
            });
        };

        const observerOptions = {
            threshold: 0.5,
        };

        const observer = new IntersectionObserver(observerLoadMoreScrollCallback, observerOptions);
        const formBlock = document.querySelectorAll('.form-block');
        const columnForm = document.querySelectorAll('.column-form');

        if (formBlock) {
            formBlock.forEach(item => {
                observer.observe(item);
            });
        }

        if (columnForm) {
            columnForm.forEach(item => {
                observer.observe(item);
            });
        }
    }

    searchForm();
});




